import React from 'react';
import { DataList, formatListData } from 'commons-ui';
import { useLocation } from 'react-router-dom';
import _map from 'lodash/map';
import _get from 'lodash/get';

import { LIST_ENTITY_NAMES } from 'constant';
import useDashboardActions from 'pages/dashboard/useDashboardActions';

import { actions } from '../../actions/conversions';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import { conversionsConfig, DEFAULT_CONFIG } from './conversionsConfig';

const useConversions = () => {
	const location = useLocation();

	const getConversionsData = () => {
		const conversions = _get(location, ['state', 'rowData', 'conversions']);
		const data = _map(Object.entries(conversions), ([key, value]) => ({ amount: key, ...(value as object), id: key }));
		return { rowCount: data?.length, data: formatListData(data) };
	};

	const { getActionHandler } = useDashboardActions(makeActionHandler, makeActionList);

	return { getConversionsData, getActionHandler };
};

const Conversions: React.FC<{}> = () => {
	const { getConversionsData, getActionHandler } = useConversions();
	return (
		<div>
			<DataList
				fetchData={getConversionsData}
				columnConfigs={conversionsConfig}
				defaults={DEFAULT_CONFIG}
				actions={actions}
				getActionHandler={getActionHandler}
				disableColumnFilter
				entity={LIST_ENTITY_NAMES.PARTNER_COUPON_CONVERSIONS}
			/>
		</div>
	);
};

export default Conversions;
